import { useEffect, useState } from "react";
import { ArrowRightAlt } from "@mui/icons-material";
import { Box, Button, Grid, styled, Typography } from "@mui/material";

import clsx from 'clsx';


import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { DOTS, UsePagination } from "../../hooks/usePagination";

const useStyles = styled({
  pageBtn: {
    
    minWidth: '32px !important',
    '&:hover': { background: `transparent !important`, color: `${'black'} !important`,border:'1px solid #EEEE' }
  },
  pageBtnActive: {
    background: `transparent !important`,
    border:`1px solid ${'black'}`,
    color: `${'black'} !important`,
    '&:hover': { backgroundColor: `transparent !important`, color: `${'black'} !important`,border:`1px solid ${'black'}` }
  },
  text: {
    fontSize: 14,
    fontWeight: 600,
    color: 'black'
  }
});

function Pagination({ tableCount, totalCount, currentPage, siblingCount = 1, onPageChange, pageSize, onPageSizeChange }) {
console.log(totalCount);
console.log(currentPage);

  const classes = useStyles();

  const [initialCount, setInitialCount] = useState(0);

  const paginationRange = UsePagination({ currentPage, totalCount, siblingCount, pageSize });

  let lastPage = paginationRange[paginationRange?.length - 1]

  useEffect(() => {
    setInitialCount((currentPage - 1) * pageSize)
  }, [currentPage, pageSize]);


  return (
    <Grid container spacing={3} justifyContent="flex-start" alignItems="center" sx={{ mt: 0 }}>
      <Grid item xl={6} md={6} xs={12} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
      <Button  sx={{backgroundColor:'#EEEEEE',width:'20px !important',p:0}}    disabled={currentPage === 1 ? true : false}
          onClick={() => onPageChange(currentPage - 1)} variant="outlined"><ChevronLeftIcon sx={{ fontSize: '22px' }} /></Button>
       

        {paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return <Typography sx={{ width: 40, fontSize: 20, fontWeight: 700, textAlign: 'center' }}>...</Typography>
          }

          return (
            <Button
              key={index}
              onClick={() => onPageChange(pageNumber)}
              sx={{border:pageNumber === currentPage ? '1px solid #0BD1D1' : ''}}
              className={clsx(classes.pageBtn, {
                [classes.pageBtnActive]: pageNumber === currentPage,
              })}
            >
              {pageNumber}
            </Button>
          )
        })}
        <Button sx={{backgroundColor:'#EEEEEE',width:'20px !important',p:0}}  disabled={currentPage === lastPage || totalCount === 0 ? true : false}
          onClick={() => onPageChange(currentPage + 1)} variant="outlined"><ChevronLeftIcon sx={{ fontSize: '22px', transform: 'rotate(180deg)' }} /></Button>
         <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography component="select" name="countPerPage" sx={{ mx: 1, px: 2, width: 'auto', border: '2px solid #B6B6B6', boxShadow: '0px 4px 4px 0px #D7DCE8', p: '5px 30px', borderRadius: '5px', color: 'black' }} onChange={onPageSizeChange}>
            <Typography component="option" value="50" sx={{ color: 'gray' }}>50</Typography>
            <Typography component="option" value="100" sx={{ color: 'gray' }}>100</Typography>
            <Typography component="option" value="150" sx={{ color: 'gray' }}>150</Typography>
          </Typography>
          <Typography variant="body2" sx={{ color: 'black' }} >/Page &nbsp;</Typography>
        </Box>
      </Grid>
      <Grid item xl={6} md={6} xs={12} sx={{ display: 'flex' }}>

       
        {/* <Typography variant="body2" sx={{ color: Colors.smokeyGrey }} >showing &nbsp;
          <Typography component="span" className={classes.text}>{totalCount === 0 ? 0 : initialCount + 1}</Typography>
          &nbsp; to &nbsp;
          <Typography component="span" className={classes.text}>{initialCount + tableCount}</Typography>
          &nbsp; of &nbsp;
          <Typography component="span" className={classes.text}>{totalCount}</Typography>
          &nbsp; entries
        </Typography> */}
      </Grid>


    </Grid>
  )
}

export default Pagination